export * from './InvestmentPerformanceIcon'
